/* eslint-disable @typescript-eslint/no-explicit-any */
import Card from '@mui/material/Card'
import { Formik } from 'formik'
import React from 'react'

import content from './content'
import schema from './schema'
import Form from '../../../components/forms/elements/Form'
import FormButton from '../../../components/forms/elements/FormButton'
import FormButtonContainer from '../../../components/forms/elements/FormButtonContainer'
import FormGrid from '../../../components/forms/elements/FormGrid'

interface Props {
  user: any
  updateData: (values) => any
  onCancel?: React.MouseEventHandler<HTMLButtonElement>
  editing?: boolean
  setLoading?: (value: boolean) => void
  displayError?: (values: any) => void
}

const UserForm: React.FC<Props> = ({
  user: initUser,
  updateData,
  editing,
  setLoading,
  displayError,
}) => {
  const user = initUser

  return (
    <Formik
      initialValues={initUser}
      validateOnMount={editing}
      enableReinitialize
      validationSchema={schema}
      onSubmit={(values, actions) => {
        setLoading(true)

        Object.keys(values).forEach((key) => {
          if (typeof values[key] === 'string') values[key] = values[key]?.trim()
        })
        const [, error] = updateData(values)
        if (error) {
          displayError({ title: error.title, message: error.message })
        }
        setLoading(false)
        actions.setSubmitting(false)
      }}>
      {(form) => {
        const updateField = (key, value) => {
          form.setFieldValue(key, value)
          form.setTouched({
            ...form.touched,
            [key]: user[key] !== value,
          })
        }

        return (
          <Form id="refund-form">
            <Card>
              <FormGrid
                content={content({
                  formDisabled: form.isSubmitting,
                  updateField,
                })}
              />
            </Card>
            <FormButtonContainer wrap={false}>
              <></>
              <FormButton
                submit
                primary
                outlined
                disabled={!form.isValid || form.isSubmitting}>
                {form.values.verified ? 'Submit' : 'Verify'}
              </FormButton>
            </FormButtonContainer>
          </Form>
        )
      }}
    </Formik>
  )
}

export default UserForm
